import { useGetPortfolioCompanyInsightsDashboardQuery } from '@api/portfolio-insight-dashboards';
import { DashboardSection } from '@g17eco/molecules/dashboard';
import { BasicAlert } from '@g17eco/molecules/alert';
import { BlockingLoader } from '@g17eco/atoms/loader';
import { GridLayoutDashboard } from '@routes/custom-dashboard/GridLayoutDashboard';
import { QueryWrapper } from '@g17eco/molecules/query/QueryWrapper';
import { InitiativeCompany } from '@g17eco/types/initiativeSurvey';
import { convertDashboardFiltersToDataFilters } from '@routes/custom-dashboard/dashboard-settings/utils';
interface Props {
  dashboardId: string;
  portfolioId: string;
  company: InitiativeCompany;
}

export const CompanyInsightsCustomDashboard = ({ dashboardId, portfolioId, company }: Props) => {
  const initiativeId = company._id;
  const query = useGetPortfolioCompanyInsightsDashboardQuery({
    portfolioId,
    initiativeId,
    dashboardId,
  });

  return (
    <QueryWrapper
      onLoading={() => <BlockingLoader />}
      query={query}
      onError={() => {
        return (
          <DashboardSection>
            <BasicAlert type='danger'>Insight dashboard not found</BasicAlert>
          </DashboardSection>
        );
      }}
      onSuccess={(dashboard) => {
        return (
          <>
            <h3 className='text-ThemeHeadingLight ps-3 mb-3'>{dashboard.title}</h3>
            <GridLayoutDashboard
              readOnly={true}
              isEditing={false}
              hideQuestionReference={true}
              gridItems={dashboard.items}
              utrsData={dashboard.utrsData}
              initiativeId={initiativeId}
              dataFilters={convertDashboardFiltersToDataFilters(dashboard.filters)}
              initiative={company}
              // Don't have rootOrg, so use company as rootOrg
              rootOrg={company}
              valueLists={dashboard.valueLists}
              surveyUnitConfigs={dashboard.surveyUnitConfigs}
              NoDataView={() => {
                return (
                  <div className='flex-grow-1 d-flex justify-content-center align-items-center'>
                    <span className='text-ThemeTextPlaceholder'>There is no company data.</span>
                  </div>
                );
              }}
            />
          </>
        );
      }}
    />
  );
};
